// Page-load guards, kept out of the DOM layer so they can be tested directly
// rather than asserted about by grepping source.

import { validateCatalog } from '../shared/catalog.js';
import { readCredential } from './credential.js';

/**
 * Runs at page load. A catalog edited and deployed without running the test
 * suite must fail visibly here, not silently serve a wrong activity.
 *
 * @param {readonly object[]} [activities]
 * @returns {{ok: true} | {ok: false, heading: string, message: string}}
 */
export function catalogGuard(activities) {
  const result = validateCatalog(activities);
  if (result.ok) return { ok: true };
  return {
    ok: false,
    heading: 'Something needs fixing',
    message: `The activity list is not valid: ${result.problems.map((p) => p.message).join('; ')}`,
  };
}

/**
 * Absence of a credential is detectable without knowing the expected value, so
 * the page can say the link is incomplete rather than letting her fill in four
 * steps and hit a refusal she cannot interpret. It does NOT judge correctness.
 *
 * @param {string} [hash]
 * @returns {{ok: true} | {ok: false, heading: string, message: string}}
 */
export function credentialPresenceGuard(hash) {
  if (readCredential(hash) !== null) return { ok: true };
  return {
    ok: false,
    heading: 'This link is incomplete',
    message: 'It is missing the part after the # that lets it work. Ask Jonathan for the full bookmarked link.',
  };
}
